import moment from 'moment';

/**
 * Calculate elapsed hours in the current month
 * @param {number} year - The year
 * @param {number} month - The month (1-12)
 * @returns {number} - Number of elapsed hours in the current month
 */
export function getElapsedHoursInCurrentMonth(year, month) {
  const now = moment();
  const monthStart = moment([year, month - 1, 1]).startOf('month');
  const monthEnd = moment([year, month - 1, 1]).endOf('month');

  // If the month is in the future, return 0
  if (now.isBefore(monthStart)) {
    return 0;
  }

  // If the month is in the past, return total hours in month
  if (now.isAfter(monthEnd)) {
    return monthEnd.daysInMonth() * 24;
  }

  // Current month - calculate elapsed hours
  const elapsedDays = now.date();
  const elapsedHours = now.hour();
  return (elapsedDays - 1) * 24 + elapsedHours;
}
